import ajax from "./ajax"
import rollbarHelper from "./rollbar_helper"
import signals from "./signals"
import intervals from "./intervals"
import vimeoManager from "./vimeo_manager"
import timeouts from "./timeouts"

function trackConsumed(media, slug) {
  signals.emit("kenhub.content_consumed", {media, slug})
  if (!window.gon.currentUser) return

  ajax.post("/content_tracking/consumed", {media, slug})
}

export function trackConsumedArticle(slug) {
  if (!slug) return

  timeouts.set(() => trackConsumed("article", slug), 2 * 60 * 1000)
}

export function trackConsumedVideo(slug, iframe) {
  if (!slug) return
  let trackingCount = 0
  const interval = intervals.set(() => {
    const viewed = vimeoManager.getPercentageViewed(iframe)
    if (viewed > 0.25) {
      trackingCount++
      if (trackingCount === 2) {
        rollbarHelper.sendErrorMsg(
          "clearInterval doesn't work",
          {viewed, interval}
        )
      }
      trackConsumed("video", slug)
      clearInterval(interval)
    }
  }, 1000)
}
